<template>
  <Dialog :open="isOpenRef" @update:open="onOpenChange">
    <DialogContent class="sm:max-w-lg max-h-[calc(100vh-4rem)] overflow-y-auto">
      <LinkSessionToObjectiveModalContent v-if="isOpenRef" />
    </DialogContent>
  </Dialog>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { Dialog, DialogContent } from '@/components/ui/dialog'
import LinkSessionToObjectiveModalContent from '@/features/programs/components/link-session-to-objective-modal/link-session-to-objective-modal-content/link-session-to-objective-modal-content.vue'
import { selectGetLinkSessionToObjectiveModal } from '@/features/ui/store/modal/modal.selectors'
import modalsStore from '@/features/ui/store/modal/modal.store'

const linkSessionToObjectiveModalRef = selectGetLinkSessionToObjectiveModal(modalsStore)
const isOpenRef = computed(() => !!linkSessionToObjectiveModalRef.value?.isOpen)

function onOpenChange(open: boolean) {
  modalsStore.toggleModal('link-session-to-objective', open)
}
</script>
